import Vue from 'vue';
import Component from 'vue-class-component';
import { EventBus } from '~/utils/eventbus';

@Component({})
export default class ConfirmationReviewModalComponent extends Vue {
    private selectedSaveChanges: boolean = false;
    private selectedDiscardChanges: boolean = false;

    constructor() {
        super();
    }

    private saveChanges() {
        this.selectedSaveChanges = true;
        EventBus.$emit(EventBus.REVIEW_CHANGES.SAVE_CHANGES_MODAL, this.selectedSaveChanges);
    }

    private discardChanges() {
        this.selectedDiscardChanges = true;
        EventBus.$emit(EventBus.REVIEW_CHANGES.DISCARD_CHANGES_MODAL, this.selectedDiscardChanges);
    }

    private onClickButton() {
        this.$emit('clicked', false);
    }
}
